import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/userData/importer/userDataImporterActions';

export default importerReducers(actions);
